import { default as Msg } from '@/i18n/components/FormattedMessage';

export const TermsOfServiceTab = () => {
  return (
    <div data-testid='termsOfServiceTab' className='one-whole padding margin-auto' style={{ maxWidth: '530px' }}>
      <ul data-testid='termsOfService' style={{ listStyleType: 'disc' }}>
        <li>
          <Msg
            id={`benefits.magentaTv.modal.termsOfService.bullet1`}
            defaultMessage='Registrierte Nutzer:innen von MieterPlus, WohnenPlus oder KäuferPlus, die einen MagentaTV Gutschein in einem dieser Bereiche generiert haben, können mit Einsatz dieses Vouchercodes den MagentaTV Flex ab 1. März 2025 für monatlich 8,50€ anstatt 10,00 € buchen.'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.termsOfService.bullet2'
            defaultMessage='Die Mindestvertragslaufzeit im MagentaTV Flex beträgt 1 Monat.'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.termsOfService.bullet3'
            defaultMessage='Diese Aktion ist nicht mit anderen Aktionen oder Gutscheinen kombinierbar und nur gültig für MagentaTV Neukund:innen.'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.termsOfService.bullet4'
            defaultMessage='MagentaTV ist über die MagentaTV App ohne zusätzliche Hardware empfangbar. Auf Wunsch kann die MagentaTV One für 5 €/Monat mit einer Mindestvertragslaufzeit von 12 Monaten erworben werden.'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.termsOfService.bullet5'
            defaultMessage='Voraussetzung für die Nutzung ist eine bestehende Internetverbindung. Für die Internetverbindung gelten die Bedingungen des jeweiligen Internetanbieters.'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.termsOfService.bullet6'
            defaultMessage='Bei Nutzung über das Mobilfunk-Datennetz erfolgt die Belastung des Datenvolumens beim jeweiligen Mobilfunk-Anbieter.'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.termsOfService.bullet7'
            defaultMessage='Der Gutschein ist gültig bis 31.12.2025.'
          />
        </li>
      </ul>
    </div>
  );
};
